class AddToCartButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.addEventListener("click", this.onClick.bind(this));
  }

  async onClick(e) {
    e.preventDefault();
    this.blur();

    const variantId = this.dataset.variantId;
    if (!variantId) {
      console.error("Missing data-variant-id");
      return;
    }

    // 1. Default quantity
    let quantity = 1;

    // 2. Look for associated <quantity-control>
    const quantityControl =
      this.parentElement.querySelector("quantity-control");
    const input = quantityControl?.querySelector("input");

    if (input && input.value) {
      quantity = parseInt(input.value, 10) || 1;
    }

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
        }),
      });

      if (!res.ok) throw new Error(`Add to cart failed (${res.status})`);

      const cart = await res.json();
      console.log("Added to cart!", cart);

      this.dispatchEvent(
        new CustomEvent("cart:add", {
          detail: { variantId, quantity, cart },
          bubbles: true,
        })
      );
      this.dispatchEvent(new CustomEvent("cart:refreshed", { bubbles: true }));
    } catch (err) {
      console.error("Add to cart error:", err);
      this.dispatchEvent(
        new CustomEvent("cart:error", {
          detail: { error: err },
          bubbles: true,
        })
      );
    }
  }
}

if (!customElements.get("add-to-cart")) {
  customElements.define("add-to-cart", AddToCartButton);
}
